// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"ca679a8a","outerContainer":"c9336c42","secondaryToolbar":"_98ecf026","doorHangerRight":"_7019e179","toolbarContainer":"_0bb4bc39","toolbarViewerMiddle":"_6c18a8f9","progressBar":"ad8a5d9f","back-to-application":"_37962f55","root":"ac7c4770","desc":"_9b0deb7d","history":"_348e8fbc","history-title":"b9ce480f","history-item":"b2d97925","history-item__text":"_93d514f7","menu":"_0e9e3171","item":"_31507915","item--disabled":"c7cc251f","info":"_71e52d1f","card":"_086a828e","link":"_2002aa41","title":"_049fc35f","title__text":"_256f6d94","title__text-secondary":"_6c0bf878"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Communities/Reports/ReportDetails/styles.styl
// module id = 2244
// module chunks = 39